<div class="language-selector__flag">
  <img
    [src]="imageUrl"
    loading="lazy"
    alt="{{ baseSite.country?.isocode | lowercase }}"
  />
</div>
<div class="language-selector__country">{{ baseSite.country?.nativeName }}</div>
<div class="language-selector__language">
  @if (baseSite.stores) {
    @for (
      language of baseSite.stores[0].languages;
      track trackByIsoCode($index, language)
    ) {
      <div class="language-selector__language-item">
        <boels-language-selector-modal-item-link
          [language]="language"
          [baseSiteCode]="baseSite.country?.isocode!"
          (languageEventEmitter)="emitBaseSiteLanguage($event)"
        >
        </boels-language-selector-modal-item-link>
        <fa-icon [icon]="faChevronRight"></fa-icon>
      </div>
    }
  }
</div>
